import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./css/App.css";
import "./backend/firebaseConfig"; // Ensure firebaseConfig.js is imported to initialize the app
import { SectionErrorsProvider } from "./frontend/HomeScreen/components/Utils/SectionErrorsContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
      <App />
    {/* <SectionErrorsProvider>
    </SectionErrorsProvider> */}
  </React.StrictMode>
);

// For performance measurement
// reportWebVitals();
